import React from 'react';
import { XIcon } from 'lucide-react';
type TrendChartProps = {
  title: string;
  dates: string[];
  values: number[];
  ticks: number[];
  decimals?: number;
  onRemove: () => void;
};
const TrendChart = ({
  title,
  dates,
  values,
  ticks,
  decimals = 0,
  onRemove
}: TrendChartProps) => {
  const left = 64;
  const right = 970;
  const top = 24;
  const bottom = 186;
  const max = Math.max(...ticks);
  const average = values.reduce((sum, v) => sum + v, 0) / values.length;
  const x = (i: number) => values.length === 1 ? left : left + i * (right - left) / (values.length - 1);
  const y = (value: number) => bottom - value / max * (bottom - top);
  const linePoints = values.map((v, i) => `${x(i)},${y(v)}`).join(' ');
  return <div className="bg-white border rounded-lg shadow-sm p-4 relative" data-id="element-1049" data-mp="2iustz192ol2q">
      <button onClick={onRemove} aria-label={`Remove ${title}`} className="absolute top-3 right-3 p-1 rounded text-gray-500 hover:text-gray-900 hover:bg-gray-100 transition-colors" data-id="element-1050" data-mp="2nt4297jpyniu">
        <XIcon className="w-4 h-4" data-id="element-1051" data-mp="1m68pm4f37opq" />
      </button>

      <h4 className="text-sm font-bold text-gray-900 text-center mb-2" data-id="element-1052" data-mp="1h5ba5zlgp8rx">
        {title}
      </h4>

      <div className="w-full h-56" data-id="element-1053" data-mp="1c683ybtqwwid">
        <svg viewBox="0 0 1000 220" className="w-full h-full" data-id="element-1054" data-mp="1c79pxbcav3ev">
          {/* Horizontal grid */}
          {ticks.map(tick => <g key={tick} data-id="element-1055" data-mp="17a17d9n8oxd3">
              <line x1={left} y1={y(tick)} x2={right} y2={y(tick)} stroke="#e5e7eb" strokeWidth="1" strokeDasharray="6,6" data-id="element-1056" data-mp="24vygwhjn5scw" />
              <text x={left - 12} y={y(tick) + 4} textAnchor="end" className="text-[10px] font-medium fill-gray-500" data-id="element-1057" data-mp="1v3surog2m55m">
                {tick}
              </text>
            </g>)}

          {/* Axes */}
          <line x1={left} y1={top} x2={left} y2={bottom} stroke="#d1d5db" strokeWidth="1" data-id="element-1058" data-mp="2itn1do9sqxhf" />
          <line x1={left} y1={bottom} x2={right} y2={bottom} stroke="#d1d5db" strokeWidth="1" data-id="element-1059" data-mp="lvpjw5zqg305" />

          {/* Average reference line */}
          <line x1={left} y1={y(average)} x2={right} y2={y(average)} stroke="#d97706" strokeWidth="1.5" strokeDasharray="4,4" data-id="element-1060" data-mp="c5d1okfe4lx6" />
          <text x={left + 8} y={y(average) - 8} className="text-[10px] font-bold fill-amber-600" data-id="element-1061" data-mp="26njsrnhv1gx">
            Average {average.toFixed(decimals === 0 ? 2 : decimals)}
          </text>

          {/* Trend line */}
          <polyline points={linePoints} fill="none" stroke="#f59e0b" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" data-id="element-1062" data-mp="1iob8ypkr4rd3" />

          {/* Points */}
          {values.map((v, i) => <circle key={i} cx={x(i)} cy={y(v)} r="4" fill="#f59e0b" stroke="#ffffff" strokeWidth="1.5" data-id="element-1063" data-mp="335kcs1i778r9" data-mpi={i} />)}

          {/* Date range */}
          <text x={left - 24} y="210" textAnchor="start" className="text-[10px] font-medium fill-gray-500" data-id="element-1064" data-mp="3d15dzxfg04zy">
            {dates[0]}
          </text>
          <text x={right} y="210" textAnchor="end" className="text-[10px] font-medium fill-gray-500" data-id="element-1065" data-mp="3lxwd6ipajzyr">
            {dates[dates.length - 1]}
          </text>
        </svg>
      </div>
    </div>;
};
export default TrendChart;